module.exports = __webpack_public_path__ + "static/media/dashboardIllustration.87500552.png";